import { render, staticRenderFns } from "./TotalConsultas.vue?vue&type=template&id=1002b2d0&scoped=true"
import script from "./TotalConsultas.vue?vue&type=script&lang=js"
export * from "./TotalConsultas.vue?vue&type=script&lang=js"
import style0 from "./TotalConsultas.vue?vue&type=style&index=0&id=1002b2d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1002b2d0",
  null
  
)

export default component.exports